import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular-ivy';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class SentryErrorHandler implements ErrorHandler {
  handleError(error: unknown): void {
    if (this.shouldLogErrorToConsole()) {
      console.error(error);
    }

    if (this.isHttpErrorResponse(error)) {
      return;
    }

    Sentry.captureException(error);
  }

  private shouldLogErrorToConsole(): boolean {
    return environment.env === 'dev' || environment.env === 'e2e';
  }

  private isHttpErrorResponse(data: unknown): data is HttpErrorResponse {
    return (
      typeof data === 'object' &&
      data !== null &&
      'name' in data &&
      'HttpErrorResponse' === (data as HttpErrorResponse).name
    );
  }
}
